var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPromoRedRibbon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 400 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    filter: "url(#filter0_ii_0_38)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M400 0H0L4.18 1.35L8.37 2.7L4.18 4.05L0 5.4L4.18 6.75L8.37 8.1L4.18 9.45L0 10.8L4.18 12.15L8.37 13.5L4.18 14.85L0 16.2L4.18 17.55L8.37 18.9L4.18 20.25L0 21.6L4.18 22.95L8.37 24.3L4.18 25.65L0 27L4.18 28.35L8.37 29.7L4.18 31.05L0 32.4L4.18 33.75L8.37 35.1L4.18 36.45L0 37.8L4.18 39.15L8.37 40.5L4.18 41.85L0 43.2L4.18 44.55L8.37 45.9L4.18 47.25L0 48.6L4.18 49.95L8.37 51.3L4.18 52.65L0 54H400L395.82 52.65L391.63 51.3L395.82 49.95L400 48.6L395.82 47.25L391.63 45.9L395.82 44.55L400 43.2L395.82 41.85L391.63 40.5L395.82 39.15L400 37.8L395.82 36.45L391.63 35.1L395.82 33.75L400 32.4L395.82 31.05L391.63 29.7L395.82 28.35L400 27L395.82 25.65L391.63 24.3L395.82 22.95L400 21.6L395.82 20.25L391.63 18.9L395.82 17.55L400 16.2L395.82 14.85L391.63 13.5L395.82 12.15L400 10.8L395.82 9.45L391.63 8.1L395.82 6.75L400 5.4L395.82 4.05L391.63 2.7L395.82 1.35L400 0Z",
    fill: "url(#paint0_linear_0_38)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_0_38",
    x: 0,
    y: -2,
    width: 400,
    height: 58,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_0_38"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_0_38",
    result: "effect2_innerShadow_0_38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_38",
    x1: 3.5,
    y1: 54,
    x2: 392.904,
    y2: -12.3097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1A1A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromoRedRibbon);
export default __webpack_public_path__ + "static/media/promo-red-ribbon.a3ab176d9feb2a25df125df7d7ed7a1c.svg";
export { ForwardRef as ReactComponent };